export const LOGO_URL = "/brand-laptop.png";

export const SMOKE_TEXTURE =
  "https://images.unsplash.com/photo-1679651216783-8d8b1f42ea77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxkYXJrJTIwc21va2UlMjBhYnN0cmFjdCUyMHJlZHxlbnwwfHx8fDE3ODcyMTc3ODB8MA&ixlib=rb-4.1.0&q=85";

export const FALLBACK_CATALOG = { platforms: [], bundles: [] };

export const FAQ_ITEMS = [
  {
    q: "Do you need my password?",
    a: "Never. Every service is delivered using only your public profile URL, post link, or track link. Your account credentials stay yours — with us you have 100% privacy.",
  },
  {
    q: "How fast does delivery start?",
    a: "Most services begin within 0–6 hours of order confirmation. Larger or targeted campaigns are paced deliberately — typically 24–72 hours — to keep delivery looking organic and to protect your account standing.",
  },
  {
    q: "Are the followers, plays, and views real?",
    a: "We route orders through vetted delivery infrastructure built for retention, not bot floods that vanish in a week. Every service lists its expected quality tier and refill policy before you pay.",
  },
  {
    q: "Can I test before committing budget?",
    a: "Yes. It's free to test our services — start with a small order on any network and watch the delivery curve yourself before scaling to bundles like 35K followers or multi-platform campaigns.",
  },
  {
    q: "Which platforms do you cover?",
    a: "Instagram, TikTok, YouTube, Spotify, and Facebook are fully wired today, across 700+ individual services. New networks are added to the catalog continuously.",
  },
  {
    q: "What if numbers drop after delivery?",
    a: "Services carry a refill or retention policy stated at purchase. If counts drop inside the guarantee window, open a ticket and the refill is processed without a new charge.",
  },
];

export const scrollToSection = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.resize();
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
